export const GET_LOAD_HISTORY = 'GET_LOAD_HISTORY';
export const UPDATE_LOAD_HISTORY = 'UPDATE_LOAD_HISTORY';
